var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.9 14.4203C0.9 14.7409 1.16813 15 1.5 15H6.8625V8.18841H0.9V14.4203ZM8.1375 15H13.5C13.8319 15 14.1 14.7409 14.1 14.4203V8.18841H8.1375V15ZM14.4 3.84058H11.6325C11.8875 3.4529 12.0375 2.99275 12.0375 2.5C12.0375 1.12138 10.8769 0 9.45 0C8.67375 0 7.97438 0.333333 7.5 0.858696C7.02563 0.333333 6.32625 0 5.55 0C4.12313 0 2.9625 1.12138 2.9625 2.5C2.9625 2.99275 3.11063 3.4529 3.3675 3.84058H0.6C0.268125 3.84058 0 4.09964 0 4.42029V6.95652H6.8625V3.84058H8.1375V6.95652H15V4.42029C15 4.09964 14.7319 3.84058 14.4 3.84058ZM6.8625 3.76812H5.55C4.82625 3.76812 4.2375 3.19928 4.2375 2.5C4.2375 1.80072 4.82625 1.23188 5.55 1.23188C6.27375 1.23188 6.8625 1.80072 6.8625 2.5V3.76812ZM9.45 3.76812H8.1375V2.5C8.1375 1.80072 8.72625 1.23188 9.45 1.23188C10.1737 1.23188 10.7625 1.80072 10.7625 2.5C10.7625 3.19928 10.1737 3.76812 9.45 3.76812Z",
    fill: "#BFF736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/giftIcon.6cea0db74e3e5f4d6a65e1260b475c4f.svg";
export { ForwardRef as ReactComponent };